export enum ModalSize {
    Medium = 'medium',
    Small = 'small',
    Large = 'large',
    Full = 'full',
    Chat = 'chat',
}
